import React from 'react';
import Header from '../Components/Header';

const TermsConditions = () => {
    return (
        // <div className="min-h-screen bg-custom-white text-custom-blue">
        <div className="w-full px-4 sm:px-6 lg:px-16 xl:px-20 py-8 max-w-7xl pt-2 mx-auto bg-custom-white text-custom-blue ">
            <Header />
            <header className="bg-custom-yellow py-6 mt-4">
                <div className="max-w-4xl mx-auto px-4">
                    <h1 className="text-3xl font-bold">Terms & Conditions</h1>
                    <p className="mt-2 text-custom-blue">Prapancha Pravasa Tours Private Limited</p>
                    <p className="text-sm">Effective Date: 27/6/2025</p>
                </div>
            </header>
            <main className="max-w-4xl mx-auto px-4 py-8">
                <p className="mb-4">Please read these Terms & Conditions (“Terms”) carefully before booking or using any services offered by Prapancha Pravasa Tours Private Limited.</p>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">1. Acceptance of Terms</h2>
                    <p>By accessing our website or booking a tour, you agree to be bound by these Terms. If you do not agree, please do not use our services.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">2. Booking and Payments</h2>
                    <ul className="list-disc pl-6">
                        <li>A booking is confirmed only after a minimum deposit (as specified per package) is received.</li>
                        <li>Full payment must be made within the specified deadline.</li>
                        <li>We accept payments through secure gateways, UPI, credit/debit cards, or bank transfer.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">3. Cancellations and Refunds</h2>
                    <p>Cancellation by the client is subject to our refund policy:</p>
                    <ul className="list-disc pl-6">
                        <li>30+ days before departure: 75% refund</li>
                        <li>15–29 days: 50% refund</li>
                        <li>Less than 15 days: No refund</li>
                    </ul>
                    <p>If the tour is cancelled by us due to unforeseen circumstances, a full refund will be provided.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">4. Passport, Visa, and Travel Documents</h2>
                    <p>Travelers are responsible for obtaining valid passports, visas, and other required documents.</p>
                    <p>We can assist with guidance but are not liable for delays or rejections by consulates.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">5. Travel Insurance</h2>
                    <p>We highly recommend all travelers purchase travel insurance. We are not responsible for any loss, damage, illness, or injury during travel.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">6. Itinerary Changes</h2>
                    <p>The itinerary is subject to change based on weather, transportation availability, or safety.</p>
                    <p>We reserve the right to make adjustments for the best travel experience.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">7. Health and Safety</h2>
                    <p>Travelers must disclose any medical condition that may affect their ability to travel.</p>
                    <p>Compliance with local laws, customs, and health guidelines is mandatory.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">8. Code of Conduct</h2>
                    <p>Respect local customs, fellow travelers, and our staff.</p>
                    <p>We reserve the right to remove any participant for misconduct, without refund.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">9. Intellectual Property</h2>
                    <p>All content on our website including text, photos, videos, and logos are property of Prapancha Pravasa and may not be used without permission.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">10. Limitation of Liability</h2>
                    <p>We are not liable for:</p>
                    <ul className="list-disc pl-6">
                        <li>Delays, cancellations, or losses caused by third-party service providers</li>
                        <li>Accidents, theft, or acts of God</li>
                        <li>Any indirect, incidental, or consequential damages</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">11. Governing Law</h2>
                    <p>These terms are governed by the laws of India, and any disputes shall be handled in courts located in Bengaluru, Karnataka.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">12. Contact</h2>
                    <p>For any questions, contact:</p>
                    <p>Prapancha Pravasa Tours Private Limited</p>
                    <p>Address: 1st Cross Rd, Kirloskar Layout, Siddeshwar Layout, Soundarya Layout, Bengaluru, Sidedahalli, Karnataka 560070</p>
                    <p>Email: <a href="mailto:book@prapanchapravasa.com" className="underline">book@prapanchapravasa.com</a></p>
                    <p>Phone: 63602 04100</p>
                </section>
            </main>
            <footer className="bg-custom-yellow py-4 text-center">
                <p>&copy; 2025 Prapancha Pravasa Tours Private Limited. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default TermsConditions;